import {Link, Text, VStack} from "@chakra-ui/react";

function Page() {
    return <VStack placeItems="center" gap={5} justifyContent="center" minH="70vh" px=".5rem" maxW="100%">
        <svg xmlns="http://www.w3.org/2000/svg" width="320" height="200" version="1.1" viewBox="0 0 52.9 26.5" style={{maxWidth: "90vi"}}>
            <path d="M25 22.6a7 7 0 0 1-5.6-4.7 16 16 0 0 1 0-9.2 7 7 0 0 1 5.4-4.9v.4c-.2.6 0 1.2.5 1.7.8.8 2.2.5 2.6-.6V4c0-.1 0-.1.4 0 3 .6 5.1 3.1 5.6 6.9a13 13 0 0 1-1.5 8.8c-.3.6-1.1 1.4-1.6 1.7-.7.5-1.6.9-2.5 1-.6.2-2.7.3-3.3.2zm2.2-3.5c1.6-.4 2.5-2 2.7-4.9.1-3-.3-5.1-1.4-6.2-.6-.6-1-.8-2-.8s-1.7.2-2.4 1c-.6.6-1 1.5-1.1 2.8-.3 1.7-.2 3.8.2 5.2.5 2 1.5 3 3.2 3l.8-.1zm-16.5 1.3v-2H6.1l-4.6.1v-2.9l1-1.5L8 6.3l1.3-1.8h4a480.7 480.7 0 0 1-7 10.4l2.2.1h2.2v-3.8h3.9V15h2.8v3.4h-2.8v3.8h-3.9Zm34-.1v-1.9h-9.3v-2.8l1.8-2.5L43 4.8l.2-.3h4a212.3 212.3 0 0 1-7 10.5h4.5v-3.9h3.9v4h2.8v3.4h-2.8v3.7h-4z" style={{fill: "#000"}}/>
        </svg>
        <Text as="h1" color="primary.500" fontWeight="bold" fontSize="1.5em">Page Not Found</Text>
        <Text color="dark.500" maxW="min(85vi, 50ch)" textAlign="center">The page you are looking for might have been moved, deleted, or does not exist. Please check the URL or try again later.</Text>
        <Link
            bg="primary.500"
            color="white"
            px="1rem"
            py=".5rem"
            transition="all .35s ease"
            href="/"
            borderRadius=".5rem"
            fontWeight="medium"
        >
            Return to Dashboard
        </Link>
    </VStack>;
}

export default Page;
